import { get, getOr, compose, isNull, negate } from 'lodash/fp';
import { createSelector } from 'reselect';
import { ApplicationState } from '@mews-commander/types';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { getScopeOptions, getScopePrivileges, getPlatformScope } from '../../ducks/scopes';

// @ts-expect-error $TSFixMeError: No overload matches this call.
export const isScopeAdmin = createSelector(getScopePrivileges, getOr(false, 'admin'));

export const hasCurrentEnterpriseId = compose(negate(isNull), getCurrentEnterpriseId);

const createPlatformPrivilegeSelector = (privilegeGetter: $TSFixMe) =>
    createSelector(
        hasCurrentEnterpriseId,
        isScopeAdmin,
        getScopePrivileges,
        (hasEnterpriseId, isAdmin, privileges) => !hasEnterpriseId && (isAdmin || privilegeGetter(privileges))
    );

const createEnterprisePrivilegeSelector = (privilegeGetter: $TSFixMe) =>
    createSelector(
        isScopeAdmin,
        getScopePrivileges,
        (isAdmin, privileges) =>
            (privileges as $TSFixMe)?.accessAllEnterprises || (privileges && (isAdmin || privilegeGetter(privileges)))
    );

export const canScopeManagePlatformProfilesWithinEnterprise = createSelector(
    hasCurrentEnterpriseId,
    getPlatformScope,
    (hasEnterpriseId, platformScope) =>
        (platformScope as $TSFixMe)?.privileges.managePlatformProfiles && hasEnterpriseId
);

const createEnterpriseOptionsSelector = (optionGetter: $TSFixMe) => createSelector(getScopeOptions, optionGetter);

export const canScopeManagePlatformProfiles = createPlatformPrivilegeSelector(get('managePlatformProfiles'));
export const canScopeRunInstallations = createPlatformPrivilegeSelector(get('runInstallation'));
export const canScopeManageContent = createPlatformPrivilegeSelector(get('manageContent'));
export const canScopeManageSubscriptions = createPlatformPrivilegeSelector(get('manageSubscriptions'));
export const canScopeManageCharitySubscriptions = createPlatformPrivilegeSelector(get('manageCharitySubscriptions'));

export const canScopeManageSpaces = createEnterprisePrivilegeSelector(get('manageSpaces'));
export const canScopeOverrideRestrictions: (state: ApplicationState, params: { profileId: string }) => boolean =
    createEnterprisePrivilegeSelector(get('overrideRestrictions'));
export const canScopeManageReservations = createEnterprisePrivilegeSelector(get('manageReservations'));
export const canScopeManageTravelAgencies = createEnterprisePrivilegeSelector(get('manageCompanyContracts'));
export const canScopeConfigureEnterprise = createEnterprisePrivilegeSelector(get('configureEnterprise'));
export const canScopeIssueInvoices = createEnterprisePrivilegeSelector(get('issueInvoices'));
export const canScopeReceiveCustomerMessages = createEnterpriseOptionsSelector(get('receiveCustomerMessages'));
export const canScopeManageEnterpriseEmployees = createEnterprisePrivilegeSelector(get('manageEmployees'));
export const canScopeManageInvoiceability = createEnterprisePrivilegeSelector(get('manageInvoiceability'));
export const canScopeViewSensitiveReports = createEnterprisePrivilegeSelector(get('viewSensitiveReports'));
export const canScopeViewCustomerData = createEnterprisePrivilegeSelector(get('viewCustomerData'));

export const canScopeManageServices = createEnterprisePrivilegeSelector(get('manageServices'));
export const canScopeManageResourceCategories = createEnterprisePrivilegeSelector(get('manageResourceCategories'));
export const canScopeManageProducts = createEnterprisePrivilegeSelector(get('manageProducts'));
export const canScopeManageBusinessSegments = createEnterprisePrivilegeSelector(get('manageBusinessSegments'));
export const canScopeManageRateGroups = createEnterprisePrivilegeSelector(get('manageRateGroups'));
export const canScopeManageProductRules = createEnterprisePrivilegeSelector(get('manageProductRules'));
export const canScopeManageRates = createEnterprisePrivilegeSelector(get('manageRates'));
export const canScopeManageRestrictions = createEnterprisePrivilegeSelector(get('manageRestrictions'));
export const canScopeManageSellLimits = createEnterprisePrivilegeSelector(get('manageSellLimits'));
export const canScopeManageServiceConfigurations = createEnterprisePrivilegeSelector(
    get('manageServiceConfigurations')
);
export const canScopeManageAvailability = createEnterprisePrivilegeSelector(get('manageAvailability'));
export const canScopeManageCounters = createEnterprisePrivilegeSelector(get('manageCounters'));
export const canScopeRebateItems = createEnterprisePrivilegeSelector(get('rebateItems'));

export const canScopeViewCompanyData = createEnterprisePrivilegeSelector(get('viewCompanyData'));
export const canScopeManageCustomersAndCompanies = createEnterprisePrivilegeSelector(get('manageAccounts'));
export const canScopeManageLoyaltyMemberships = createEnterprisePrivilegeSelector(get('manageLoyaltyMemberships'));
export const canScopeManageMailQueue = createEnterprisePrivilegeSelector(get('manageMailQueue'));
export const canScopeOverrideRatePrice = createEnterprisePrivilegeSelector(get('overrideRatePrice'));
